import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportDRE, getQuestReportDREAccrual } from './DRE.services';

export function useQuestReportDRE() {
  return useMutation(getQuestReportDRE, {
    onSuccess() {
      notification.success({
        message:
          'O relatório Demonstrativo de Resultado foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useQuestReportDREAccrual() {
  return useMutation(getQuestReportDREAccrual, {
    onSuccess() {
      notification.success({
        message:
          'O relatório Demonstrativo de Resultado por competência foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
